__webpack_require__.p = "https://research.glprotocol.com/";